/**
 * Single source of truth for normalizing the configured job-docs client URL.
 *
 * Both the drawer (which feeds it as the zone `src`) and {@link useJobDocsIframe}
 * (which builds the grid URL from it) must agree on the exact string, or the
 * render gate and the zone origin can silently drift. Normalization is:
 *   1. whitespace-trim, and
 *   2. strip a single trailing slash.
 *
 * A non-string input yields `''` (treated as "not configured").
 *
 * @param {unknown} url Configured client URL.
 * @returns {string} Normalized URL, or `''` when the input is not a string.
 */
export function normalizeClientUrl(url) {
  if (typeof url !== 'string') return '';
  const trimmed = url.trim();
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
}
